import React, { useState, useEffect } from "react";
import axiosInstance from "../api/axios";
import { fetchFollowers, fetchFollowing } from "../api/UserAPI";
import { useInfiniteScroll } from "../hooks/useInfiniteScroll";
// displays a list of users
// TODO: add actions (message, friend request etc.) to users in list

export default function UserDisplayModal({ username, mode, message }) {
  const [users, setUsers] = useState([]);
  const [nextUrl, setNextUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const emptyMessage = message || "Nothing to see here!";

  const userDisplayFetchers = {
    followers: ({ username }) => fetchFollowers(username),
    following: ({ username }) => fetchFollowing(username),
  };

  const fetchInitial = async () => {
    const fetcher = userDisplayFetchers[mode];
    if (!fetcher) {
      console.error(`Unsupported user display mode: ${mode}`);
      setUsers([]);
      setNextUrl(null);
      return;
    }

    setLoading(true);
    try {
      const res = await fetcher({ username });
      setUsers(res.results);
      setNextUrl(res.next);
    } finally {
      setLoading(false);
    }
  };

  const handleLoadMore = async () => {
    if (!nextUrl || loading) return;

    setLoading(true);
    try {
      const res = await axiosInstance.get(nextUrl);
      setUsers((prev) => [...prev, ...res.data.results]);
      setNextUrl(res.data.next);
    } finally {
      setLoading(false);
    }
  };

  const loaderRef = useInfiniteScroll(handleLoadMore);

  useEffect(() => {
    if (!username) return;
    fetchInitial();
  }, [username, mode]);

  if (!loading && users.length === 0) {
    return (
      <div
        className="flex flex-col bg-white w-full max-w-xl sm:min-w-[400px] md:min-w-[480px] max-h-[60vh] h-[60vh] relative overflow-hidden rounded-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <p>{emptyMessage}</p>
      </div>
    );
  }
  return (
    <div
      className="flex flex-col bg-white w-full max-w-xl sm:min-w-[400px] md:min-w-[480px] max-h-[60vh] h-[60vh] relative overflow-hidden rounded-xl"
      onClick={(e) => e.stopPropagation()}
    >
      <ul className="w-full overflow-y-auto">
        {users.map((u) => (
          <li key={u.id} className="flex items-center gap-3 p-3 cursor-pointer hover:bg-gray-100">
            <img
              src={u.profile_pic_url || `${process.env.PUBLIC_URL}/logo512.png`}
              alt={u.user || u.username}
              className="h-9 w-9 rounded-full object-cover border"
            />
            <div className="flex-1">
              <div className="font-medium">{u.user || u.username}</div>
            </div>
          </li>
        ))}
      </ul>

      {nextUrl && (
        <div ref={loaderRef} className="h-[1px]">
          {loading && "Loading..."}
        </div>
      )}
    </div>
  );
}
